import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { AgentRecipe, agentRecipeActions } from "../../redux/reducers/agentRecipeSlice";
import { DataTable } from "../../components/DataTable";
import { useAppDispatch, useAppSelector } from "../../redux";
import { PageLayout } from "../../components/PageLayout";

export const AgentRecipesPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const recipeEntities = useAppSelector((state) => state.agentRecipe.entities);
  const isLoading = useAppSelector((state) => state.agentRecipe.isLoading);
  const recipes = useMemo(() => Object.values(recipeEntities), [recipeEntities]);

  const onClickItem = (id: string) => {
    navigate(`/agents/recipes/${id}`);
  };

  const onClickCreate = async () => {
    try {
      // Dispatch the create action and wait for it to complete
      const resultAction = await dispatch(agentRecipeActions.create({})).unwrap();

      // Navigate to the newly created recipe's details page
      if (resultAction?.id) {
        navigate(`/agents/recipes/${resultAction.id}`);
      }
    } catch (error) {
      console.error("Failed to create new recipe:", error);
    }
  };

  const filterRecipes = (searchQuery: string, item: Record<string, unknown>) => {
    const recipe = item as AgentRecipe;
    const recipeName = recipe.name?.toLowerCase() || "";
    const recipeDescription = recipe.description?.toLowerCase() || "";

    return recipeName.includes(searchQuery.toLowerCase()) || recipeDescription.includes(searchQuery.toLowerCase());
  };

  const sortRecipes = (a: Record<string, unknown>, b: Record<string, unknown>) => {
    const recipeA = a as AgentRecipe;
    const recipeB = b as AgentRecipe;

    return new Date(recipeB.updatedAt).getTime() - new Date(recipeA.updatedAt).getTime();
  };

  useEffect(() => {
    dispatch(agentRecipeActions.get({}));
  }, [dispatch]);

  return (
    <PageLayout
      title="Recipes"
      description="Create agents from recipes. Recipes help you define reusable workflows for your agents."
    >
      <DataTable
        key={recipes.length}
        entityName="recipe"
        emptyMessage={`Create your first recipe to get started.\nRecipes help you define reusable workflows for your agents.`}
        filter={filterRecipes}
        sort={sortRecipes}
        isLoading={isLoading}
        onClickCreate={onClickCreate}
        items={recipes}
        onRowClick={onClickItem}
        showCreate={false}
        showIcons={true}
        iconName="recipe"
      />
    </PageLayout>
  );
};
